import React from "react";
import "./sponsorship.component.css";
import FooterComponent from "../footer/footer";
import { Helmet } from "react-helmet-async";
import HeaderComponent from "../header/header";
import NavbarComponent from "../header/top.navbar";
import drdo from "../../assets/sponsorship/drdo-new-logo.png";
import bel from "../../assets/sponsorship/bel_logo.png";
import astral from "../../assets/sponsorship/astral_logo.png";
import lotus from "../../assets/sponsorship/lotus_logo.png";
import digilogic from "../../assets/sponsorship/digilogic_logo.png";
import mistral from "../../assets/sponsorship/mistral_logo.png";
import sanlayan from "../../assets/sponsorship/sanlayan_logo.png";
import centum from "../../assets/sponsorship/centum_logo.png";
import amd from "../../assets/sponsorship/amd_logo.jpg";
import apc from "../../assets/sponsorship/apc_logo.png";
import apex from "../../assets/sponsorship/apex_logo.png";
import qorvo from "../../assets/sponsorship/qorvo_logo.jpg";
import rfmw from "../../assets/sponsorship/rfmw_logo.png";
import rhode from "../../assets/sponsorship/rhode_logo.png";
import bdl from "../../assets/sponsorship/bdl_logo.png";
import indrainsignia from "../../assets/sponsorship/indrainsignia_logo.png";
import clear from "../../assets/sponsorship/clear_logo.png";
import brahmos from "../../assets/sponsorship/brahmos_logo.png";
import paras from "../../assets/sponsorship/paras_logo.png";
import macnica from "../../assets/sponsorship/macnica_logo.png";
import ltlogo from "../../assets/sponsorship/lt_logo.png";
import texas from "../../assets/sponsorship/texas_logo.png";
import versa from "../../assets/sponsorship/versa_logo.png";


const sponsorships = [
    { id: 1, name: "DRDO", type: "Signature", logo: drdo, url: "https://www.drdo.gov.in/drdo/headquarter-directorates/extramural-research-intellectual-property-rights-er-ipr" },
    { id: 2, name: "M/s. BEL Bengaluru", type: "Platinum", logo: bel, url: "https://bel-india.in/manufacturing-units/bangalore-unit-2/" },
    { id: 3, name: "M/s. BDL Hyderabad", type: "Diamond", logo: bdl, url: "https://bdl-india.in/" },
    { id: 4, name: "M/s. Astra Microwave Products Limited", type: "Diamond", logo: astral, url: "https://astramwp.com/" },
    { id: 5, name: "M/s. Lotus Microwave Technologies Pvt Ltd", type: "Diamond", logo: lotus, url: "https://lotusamt.com/" },
    { id: 6, name: "M/s. Digilogic Systems Pvt. Ltd", type: "Gold", logo: digilogic, url: "https://www.digilogicsystems.com/" },
    { id: 7, name: "M/s. Mistral Solutions Pvt. Ltd", type: "Gold", logo: mistral, url: "https://www.mistralsolutions.com/" },
    { id: 8, name: "M/s. Sanlayan Technologies Pvt Ltd", type: "Gold", logo: sanlayan, url: "https://www.sanlayan.com/" },
    { id: 9, name: "M/s. Centum Electronics Limited", type: "Gold", logo: centum, url: "https://www.centumelectronics.com/" },
    { id: 10, name: "M/s. AMD", type: "Gold", logo: amd, url: "https://www.amd.com/en.html" },
    { id: 11, name: "M/s. RFMW Innovations Lab Pvt Ltd", type: "Gold", logo: rfmw, url: "https://irfmw.com/" },
    { id: 12, name: "M/S. Rohde & Schwarz", type: "Gold", logo: rhode, url: "https://www.rohde-schwarz.com/in/home_48230.html" },
    { id: 13, name: "M/s. Indra Insignia", type: "Gold", logo: indrainsignia, url: "https://indrainsignia.co.in/" },
    { id: 14, name: "M/s. Clear Communication Systems Ltd", type: "Gold", logo: clear, url: "http://www.optiwavephotonics.com/" },
    { id: 15, name: "M/s. Larsen & Toubro: L&T India", type: "Gold", logo: ltlogo, url: "https://www.larsentoubro.com/" },
    { id: 16, name: "M/s. Texas Instruments", type: "Gold", logo: texas, url: "https://www.ti.com/" },
    { id: 17, name: "M/s. Versabyte Data System Pvt Ltd", type: "Gold", logo: versa, url: "https://www.versabyte.com/" },
    { id: 18, name: "M/s. APC Technologies", type: "Silver", logo: apc, url: "https://apctechnologies.in/" },
    { id: 19, name: "M/s. Brahmos aerospace Pvt Ltd", type: "Silver", logo: brahmos, url: "https://www.brahmos.com/" },
    { id: 20, name: "M/s. Paras Defence and Space Technologies Ltd", type: "Silver", logo: paras, url: "https://parasdefence.com/" },
    { id: 21, name: "M/s. Qorvo India", type: "Silver", logo: qorvo, url: "https://www.qorvo.com/" },
    { id: 22, name: "M/s. Macnica Cytech Pte Ltd", type: "Silver", logo: macnica, url: "https://www.macnica.com/apac/macnicacytech/en/" },
];

const typePriority = {
    Signature: 1,
    Platinum: 2,
    Diamond: 3,
    Gold: 4,
    Silver: 5,
};

const SponsorshipCards = () => {
    const sortedSponsors = sponsorships.sort(
        (a, b) => typePriority[a.type] - typePriority[b.type]
    );

    return (
        <>
            <Helmet>
                <title>ABOUT US SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
                <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
                <meta name="robots" content="index, follow" />
            </Helmet>
            <HeaderComponent />
            <NavbarComponent />
            <section id="fixed-sub-nav" className="gradient-background" style={{ paddingBottom: '30px', paddingTop: '30px' }}>
                <div className="container pt-4">
                    <div className="row g-4">
                        {sortedSponsors.map((sponsor, index) => (
                            <div className="col-sm-6 col-md-4 col-lg-3" key={sponsor.index}>
                                <div className="card h-100 fade-in card-spons" style={{alignItems:'center'}}>
                                    <img
                                        src={sponsor.logo}
                                        className="card-img-top p-2"
                                        alt={`${sponsor.name} logo`}
                                        style={
                                            sponsor.type === "Signature"
                                              ? { height: "145px", width: "55%", objectFit: "contain" }
                                              : { height: "145px", width: "100%", objectFit: "contain" }
                                          }
                                    />
                                    <div className="card-body text-center p-4">
                                        <h5 className="card-title sponsor-name">{sponsor.name}</h5>
                                        <span
                                            className={`badge rounded-pill sponsor-badge ${sponsor.type.toLowerCase()}-badge`}
                                            >
                                            {sponsor.type} Sponsorship
                                        </span>
                                    </div>
                                    <div className="card-footer text-center bg-transparent border-0 p-4">
                                        <a href={sponsor.url} target="_blank" rel="noopener noreferrer" className="btn btn-sm button-url">
                                            View Sponsor
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <FooterComponent />
        </>
    );
};

export default SponsorshipCards;
